module.exports = __webpack_public_path__ + "static/media/check-blue.082ddd1d.svg";